// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"Breadcrumb_Breadcrumb__Hmbcr","crumb":"Breadcrumb_crumb__sFoab","separator":"Breadcrumb_separator__DKxoT"};